import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { School } from '../../../../../../../models/school';
import { SchoolForm } from '../../../../../../../models/form';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../SchoolLeagues.css';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; school: School; forms: SchoolForm[]; }

export function TargetCompletionStatisticsReportForm({ onCloseClick, onSubmit }: Props) {
  const initialValues = { isPrintParticipating: true, isPrintPercent: true, isPrintPP: true, isPrintSEN: true, isPrintFSM: true, isSelectAllAges: true };
  return (
    <Formik initialValues={initialValues} onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TARGET_COMPLETION_STATISTICS)}>
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <div className="eReportForm__scroll">
            <ReportDescription>Analyse target completion across the selected leagues.</ReportDescription>
            <ReportSection number={1} title="Completion data" hint="Choose the figures included in the report.">
              <ReportToggleList>
                <ReportToggle name="isPrintParticipating" label="Participating students" hint="Show the number of students taking part in each activity." value={values.isPrintParticipating} onChange={value => setFieldValue('isPrintParticipating', value)} />
                <ReportToggle name="isPrintPercent" label="Completion percentages" hint="Show completion as a percentage of participating students." value={values.isPrintPercent} onChange={value => setFieldValue('isPrintPercent', value)} />
              </ReportToggleList>
            </ReportSection>
            <ReportSection number={2} title="Student information" hint="Choose additional breakdowns to include.">
              <ReportToggleList>
                <ReportToggle name="isPrintPP" label="PP breakdown" hint="Include figures for students marked as PP." value={values.isPrintPP} onChange={value => setFieldValue('isPrintPP', value)} />
                <ReportToggle name="isPrintSEN" label="SEN breakdown" hint="Include figures for students marked as SEN." value={values.isPrintSEN} onChange={value => setFieldValue('isPrintSEN', value)} />
                <ReportToggle name="isPrintFSM" label="FSM breakdown" hint="Include figures for students receiving free school meals." value={values.isPrintFSM} onChange={value => setFieldValue('isPrintFSM', value)} />
              </ReportToggleList>
            </ReportSection>
          </div>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
